// Firebase configuration is sourced from the active environment bundle
// (selected by REACT_APP_APPLI_ENV in src/config/environments.js).
import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import env from '../config/environments';

// Initialize Firebase
const app = initializeApp(env.firebase);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
